import {
  Input,
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { VIDEO_SECTION_LIST,
         Invalid_Youtube_Video_URL } from '@root/app.constant';
import { CatalogService } from '@catalog/catalog.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { VideoData } from './../catalogue-video.model';

@Component({
  selector: 'app-catalogue-video-form',
  templateUrl: './catalogue-video-form.component.html',
  styleUrls: ['./catalogue-video-form.component.scss'],
  providers: [CatalogService],
})
export class CatalogueVideoFormComponent implements OnInit, OnChanges {
  @ViewChild('f', { static: false }) form: NgForm;

  @Input() videoData: VideoData;

  @Output() sectionChange = new EventEmitter<string>();

  @Output() refreshChange = new EventEmitter<string>();

  selectedVedioSection: string;

  @Input() selectedTab:string;

  schemeList = [];
  vedioSectionList: { name: string; value: string; };

  constructor(
    private catalogService: CatalogService,
    private toastr: ToastrService
  ) {}

  public readAllVideoSchems() {
    this.catalogService.readAllSchemes().subscribe(
      (response) => {
        this.schemeList = response.data.schemes;
      },
      (error) => {}
    );
  }

  public onVideoSectionChange(change: MatSelectChange) {
    this.sectionChange.emit(this.selectedVedioSection);
  }

  public processData() {
    const validURL = this.videoData.videoUrl.startsWith('https://www.youtube.com/watch?') || this.videoData.videoUrl.startsWith('https://youtu.be/');
    if (!validURL) {
      this.toastr.error(Invalid_Youtube_Video_URL);
      return;
    }

    this.catalogService
      .uploadVideoData(this.videoData, this.selectedVedioSection)
      .subscribe(
        (response) => {
          if (response.status === 0) {
            this.toastr.success(response.message);
            this.refreshChange.emit(this.selectedVedioSection);
            this.resetForm(this.selectedVedioSection);
          } else {
            this.toastr.error(response.error.errorMessage);
          }
        },
        (error) => {
          this.toastr.error(error.error.errorMessage);
        }
      );
  }

  private resetForm(section?: string) {
    this.videoData = new VideoData();
    this.form.resetForm();
    setTimeout(() => {
      this.selectedVedioSection = section
        ? section
        : VIDEO_SECTION_LIST[0].value;
    });
  }

  ngOnInit() {
    if(this.selectedTab==='Products'){
      this.selectedVedioSection = VIDEO_SECTION_LIST[0].value;
      this.vedioSectionList = VIDEO_SECTION_LIST[0];
    }else{
      this.vedioSectionList = VIDEO_SECTION_LIST[1];
      this.selectedVedioSection = VIDEO_SECTION_LIST[1].value;
    }
    this.sectionChange.emit(this.selectedVedioSection);
    this.readAllVideoSchems();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['videoData'] && this.videoData) {
    }
  }
}
